import { getPlayerAvatar } from '../../utils/player';
import { Swords } from 'lucide-react';

const InsightCard = ({ title, value, icon, iconBgColor, subtext, playerName, allPlayers, isGold = false, index = 0, onClick }) => {
  // Check if playerName is a pair (contains " & ")
  const isPair = playerName && playerName.includes(' & ');
  let playerAvatar = null;
  let playerAvatar2 = null;
  
  if (isPair) {
    const players = playerName.split(' & ');
    playerAvatar = players[0] ? getPlayerAvatar(allPlayers, players[0]) : null;
    playerAvatar2 = players[1] ? getPlayerAvatar(allPlayers, players[1]) : null;
  } else {
    playerAvatar = playerName ? getPlayerAvatar(allPlayers, playerName) : null;
  }
  
  // Gold gradient for icon background - using a lighter gold gradient for the circle background
  // to create contrast with the darker gradient fill on the icon symbol
  const goldGradientBg = 'linear-gradient(180deg, rgba(245, 222, 125, 1) 0%, rgba(244, 214, 131, 1) 50%, rgba(244, 202, 83, 1) 50%, rgba(234, 169, 56, 1) 100%)';
  // Darker gold gradient for icon fill (user specified)
  const goldGradientFill = 'linear-gradient(180deg, #855C0D 0%, #322201 100%)';
  const iconStyle = isGold 
    ? { background: goldGradientBg }
    : { backgroundColor: iconBgColor };
  
  return (
    <div
      className={`insight-card ${isGold ? 'insight-card-gold' : ''} ${onClick ? 'insight-card-link' : ''}`}
      style={{ '--ins-i': index }}
      {...(onClick && {
        role: 'button',
        tabIndex: 0,
        onClick,
        onKeyDown: (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick();
          }
        },
      })}
    >
      <div className="insight-card-icon" style={iconStyle}>
        {icon === 'swords' ? (
          <Swords size={24} color={isGold ? '#855C0D' : '#FFFFFF'} strokeWidth={2.2} />
        ) : typeof icon === 'string' ? (
          <span className="material-symbols-outlined">{icon}</span>
        ) : (
          icon
        )}
      </div>
      <div className="insight-card-content">
        <div className="headline-small">{title}</div>
        {playerName && (
          <div className="body-medium">{playerName}</div>
        )}
        {subtext && (
          <div className="caption">{subtext}</div>
        )}
      </div>
      {isPair && playerAvatar && playerAvatar2 ? (
        <div className="insight-card-avatar insight-card-avatar-pair">
          <img
            src={playerAvatar}
            alt={`${playerName.split(' & ')[0]}'s avatar`}
            className="avatar avatar-md avatar-border"
          />
          <img
            src={playerAvatar2}
            alt={`${playerName.split(' & ')[1]}'s avatar`}
            className="avatar avatar-md avatar-border"
          />
        </div>
      ) : playerAvatar ? (
        <div className="insight-card-avatar">
          <img
            src={playerAvatar}
            alt={`${playerName}'s avatar`}
            className="avatar avatar-md avatar-border"
          />
        </div>
      ) : null}
      {onClick && (
        <span className="material-symbols-outlined insight-card-chevron" aria-hidden="true">chevron_right</span>
      )}
    </div>
  );
};

export default InsightCard;

